/**
 * @desc 全局依赖
 * @time 2023-07-31 16:02:22
 * @user simxin
 */

import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import { trtcCGIRequest } from '@src/utils/api/request';
import { getUin, getOwnUin } from '@src/utils/cookies';

/**
 * @desc external package
 */
window.React16 = React;
window.ReactDOM16 = ReactDOM;
window.moment = moment;

/**
 * @desc mock nmc 方法
 * @file qcloud-console/web/app/zh/main/api.js
 */
window.nmc = {
  render: (dom, mod) => {
    let area = document.getElementById('app-area');
    if (!area) {
      const areaWrap = document.getElementById('app-area-wrap');
      area = document.createElement('div');
      area.id = 'app-area';
      areaWrap.appendChild(area);
    }
    area.innerHTML = dom.replace('tea-page-root', 'trtc-tea-page-root');
  },
};

/**
 * @desc mock Insight 方法
 * @file qcloud-console/web/nmc/insight/insight.js
 */
window.Insight = {
  EventLevel: {},
  register: () => [],
  captureTrace: () => {},
  stat: () => {},
  reportHotTag: () => {},
};

/**
 * @desc mock g_buffet_data 数据
 */
window.g_buffet_data = {
  navigation: [],
};


/**
 * @desc mock devmode
 */
window.devmode = {
  getStatus: () => 'off',
};

/**
 * @desc mock version
 */

/**
 * @desc mock LOGIN_INFO 依赖
 * @file // qcloud-console/server/views/index.ejs
 */
window.LOGIN_INFO = {
  area: 2,
  ownerUin: getOwnUin(),
  loginUin: getUin(),
  appId: undefined,
  isOwner: getUin() === getOwnUin(),
  nickname: '',
};

/**
 * @desc mock console base
 */
window.QC_HOST = 'cloudcache.tencent-cloud.com';
// window.QCCDN_HOST = 'static.cloudcachetci.com';
window.QCCDN_HOST = 'cloudcache.tencent-cloud.com';

/**
 * @desc global variable
 */
window.AVPORTAL = true;
window.AVPORTAL_HOST = import.meta.env.VITE_ENV_AVPORTAL_HOST;
window.AVCONSOLE_HOST = import.meta.env.VITE_ENV_AVCONSOLE_HOST;
// trtc.tencentcloud.com,，无对应的旧域名，且这个域名不用了
window.AVTRTC_HOST = import.meta.env.VITE_ENV_AVTRTC_HOST;

/**
 * @desc static
 */
window.AVSTATIC_PATH = `//${window.AVCONSOLE_HOST}/mod/`;

/**
 * @desc api
 */
window.AVAPI_TRTC_HOST = import.meta.env.VITE_ENV_CGI_API;

/**
 * @desc fetch fn
 */
window.AVFN_TRTC_CGI_REQUEST = trtcCGIRequest;

/**
 * @desc qc variable
 */
window.AVQC_COMMIT = import.meta.env.VITE_ENV_COMMIT;
